/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'goal-fields.goal-followers.add-followers-title': 'Follower hinzufügen',
  'goal-fields.goal-followers.title': 'Follower',
  'goal-fields.goal-links.add-parent-goal-title': 'Ein übergeordnetes Ziel hinzufügen',
  'goal-fields.goal-links.edit-parent-goal-title': 'Übergeordnetes Ziel bearbeiten',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Verknüpfung zum übergeordneten Ziel aufheben',
  'goal-fields.goal-metrics.automatic-metric-title': 'Aus Unterzielen',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.remove-label': 'Entfernen',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.settings-label': 'Einstellungen',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.show-more': 'Mehr anzeigen',
  'goal-fields.goal-metrics.goal-metrics-info-section-dropdown-menu.update-value-label': 'Wert aktualisieren',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Start:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Ziel:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'Der Fortschritt wird automatisch über {compass} ausgefüllt. Diese Zielmetrik kann nur in {compass} bearbeitet werden.',
  'goal-fields.goal-metrics.no-metrics-instructions':
    'Rufen Sie die vollständige Zielseite auf, um dieses Feld zu ändern',
  'goal-fields.goal-metrics.no-metrics-title': 'Keine Metrik',
  'goal-fields.goal-metrics.open-in-new-window-label': 'In neuem Fenster offen',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'erzielter Fortschritt',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals':
    'Keine Unterziele mit Metriken mit diesem Ziel verbunden',
  'goal-fields.goal-metrics.title': 'Fortschritt',
  'goal-fields.goal-owner.title': 'Besitzer',
  'goal-fields.goal-start-date.add-start-date-title': 'Startdatum hinzufügen',
  'goal-fields.goal-start-date.cancel-button': 'Speichern',
  'goal-fields.goal-start-date.creation-date': 'Dieses Ziel wurde am {creationDate} erstellt.',
  'goal-fields.goal-start-date.edit-start-date-label': 'Startdatum des Ziels bearbeiten',
  'goal-fields.goal-start-date.enter-start-date-title': 'Startdatum eingeben',
  'goal-fields.goal-start-date.open-calendar-label': 'Kalender öffnen',
  'goal-fields.goal-start-date.title': 'Startdatum',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'In Bearbeitung',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Weitere Status',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'Was ist der aktuelle Status?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Möchten Sie die Anwendung von OKRs (Hauptergebnissen und Zielsetzungen) üben? <link>Erfahren Sie, wie Sie Ziele für OKRs verwenden</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Hilfelink',
  'goal-fields.goal-status.archived': 'Archiviert',
  'goal-fields.goal-status.at-risk': 'In Gefahr',
  'goal-fields.goal-status.cancelled': 'Abgebrochen',
  'goal-fields.goal-status.completed': 'Abgeschlossen 🎉',
  'goal-fields.goal-status.off-track': 'Nicht auf Kurs',
  'goal-fields.goal-status.on-track': 'Auf Kurs',
  'goal-fields.goal-status.paused': 'Angehalten',
  'goal-fields.goal-status.pending': 'Ausstehend',
  'goal-fields.goal-status.title': 'Status',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Unterziele hinzufügen',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Verknüpfung zum Unterziel aufheben',
  'goal-fields.goal-tags.add-tags-title': 'Tags hinzufügen',
  'goal-fields.goal-tags.title': 'Tags',
  'goal-fields.goal-target-date.picker-placeholder': 'Ausstehend',
  'goal-fields.goal-target-date.title': 'Zieldatum',
  'goal-fields.goal-type.goal': 'Ziel',
  'goal-fields.goal-type.key-result': 'Hauptergebnis',
  'goal-fields.goal-type.objective': 'Objective',
  'goal-fields.goal-type.title': 'Typ',
  'goal-fields.parent-goal.title': 'Übergeordnetes Ziel',
  'goal-fields.sub-goals.title': 'Unterziele',
  'goal-fields.teams.add-teams-title': 'Teams hinzufügen',
  'goal-fields.teams.follow-team': 'Team folgen',
  'goal-fields.teams.remove-team': 'Team entfernen',
  'goal-fields.teams.search-team-placeholder': 'Team suchen',
  'goal-fields.teams.show-more': 'Mehr anzeigen',
  'goal-fields.teams.title': 'Teams',
  'goal-fields.teams.verified-team-label': 'Verifiziertes Team',
  'goal-fields.teams.view-profile': 'Profil anzeigen',
  'goal-fields.use-goal-flags.generic-error-description':
    'Etwas ist schiefgelaufen. Versuchen Sie es in ein paar Minuten erneut.',
  'goal-fields.use-goal-flags.generic-error-title': 'Etwas ist schiefgelaufen',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Zielbesitzer konnte nicht geändert werden',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'Tag konnte nicht hinzugefügt werden',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Tag konnte nicht erstellt werden',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'Der eingegebene Tag-Name ist zu lang. Bitte geben Sie einen Tag-Namen mit maximal 255 Zeichen ein.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'Tag konnte nicht erstellt werden',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Tag konnte nicht entfernt werden',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title':
    'Fehler beim Hinzufügen des Teams, bitte versuchen Sie es erneut',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title':
    'Fehler beim Entfernen des Teams, bitte versuchen Sie es erneut',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Übergeordnetes Ziel konnte nicht geändert werden',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Startdatum konnte nicht geändert werden',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Zieldatum konnte nicht geändert werden',
  'townsquare.goal-fields.tag': 'Tag entfernen',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {An {usageCount,number} Ort verwendet} other {An {usageCount,number} Orten verwendet}}',
};
